/*
 * @Author: pengli.coder
 * @Date: 2021-10-27 20:04:51
 * @LastEditTime: 2021-10-27 20:30:06
 * @LastEditors: Please set LastEditors
 * @Description: refresh the context of the pre-start queue with the context at start
 */
import { __assign } from "tslib";
export var refreshPreStartContext = function () { return ({
    name: 'refreshPreStartContext',
    setup: function (client) {
        client.on('start', function () {
            var preStartQueue = client.getPreStartQueue();
            preStartQueue.forEach(function (ev, index) {
                var _a, _b;
                preStartQueue[index] = __assign(__assign({}, ev), { overrides: __assign(__assign({}, ((_a = ev.overrides) !== null && _a !== void 0 ? _a : {})), { 
                        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                        context: ((_b = client === null || client === void 0 ? void 0 : client.context) === null || _b === void 0 ? void 0 : _b.toString()) || {} }) });
            });
        });
    },
}); };
//# sourceMappingURL=refreshPreStartContext.js.map